import { render, staticRenderFns } from "./PrescriptionItemSelectLR.vue?vue&type=template&id=cbf099e4&scoped=true"
import script from "./PrescriptionItemSelectLR.vue?vue&type=script&lang=ts"
export * from "./PrescriptionItemSelectLR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf099e4",
  null
  
)

export default component.exports